// Welcher Modus gilt nach einem Klick auf den Hell/Dunkel-Umschalter?
// Reine Logik, damit sie ohne Browser prüfbar ist (theme-wahl.test.mjs).

import type { ThemeMode } from "./theme.svelte";

/** Ist die Oberfläche bei diesem Modus dunkel? */
export function istDunkelBei(mode: ThemeMode, systemDunkel: boolean): boolean {
  return mode === "dark" || (mode === "auto" && systemDunkel);
}

/** Der Umschalter zeigt das Gegenteil von dem, was gerade zu sehen ist.
 *
 *  Trifft das Gegenteil, was das System ohnehin vorgibt, gilt wieder
 *  „Auto" statt einer festen Wahl: wer abends am Mac kurz auf dunkel
 *  schaltet und morgens zurück, soll danach nicht fest auf „Hell"
 *  stehen, sondern wieder dem System folgen. Ein Klick hin, ein Klick
 *  zurück -- und es ist, als wäre nichts gewesen. (Seit 10.10.2026 gilt
 *  die Wahl je Gerät, lib/prefs-geraet.ts; die Regel bleibt dieselbe.) */
export function naechsterModus(mode: ThemeMode, systemDunkel: boolean): ThemeMode {
  const dunkel = !istDunkelBei(mode, systemDunkel);
  if (dunkel === systemDunkel) return "auto";
  return dunkel ? "dark" : "light";
}
